export enum BackendEventTypeEnum {
  USER_VIEW_PRODUCT = "user_view_product",
}

export type BackendEvent = {
  type: BackendEventTypeEnum;
  subjectId: number | string;
};
